module.exports = __webpack_public_path__ + "static/media/downArrow.3903672a.svg";